<template>
  <div class="transition">
    <div class="transition-items">
      <div class="icon-items">
        <BasicIcon
          name="info"
          active
        />
      </div>

      <BasicText>
        Pour effectuer cette démarche, vous devez vous connecter sur l’espace spécifique de la branche du travail
        temporaire
      </BasicText>

      <BasicLink
        label="Espace travail temporaire"
        @link-click="redirectExterne('https://espaceentreprise.faftt.fr/s/login/', '_self')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { redirectExterne } from '@/features/shared/tools/url'
</script>

<style lang="less" scoped>
  @import './ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @info-500;
    align-self: center;
    margin-bottom: 10px;
    svg {
      fill: @info-500;
      transform: scale(3);
    }
  }
</style>
